import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsGarbageModel {
  id: string;
  title: string;
  markerPopupText: string;
  rfid: string;
  binCapacity: string;
  binColor: string;
  binFullnessThreshold: number;
  binId: string;
  binLoggedTime: string;
  binMaxLoad: number;
  binRecommendedLoad: number;
  licensePlate: string;
  wardId: string;
  binCategory: string;
  binClearedTime: string;
  binFillingLevel: string;
  location: string | null;
  binAddress?: string;
  binName?: string;
  typeWaste?: string;
  icon: Icon;
}

export class GarbageModel extends MarkerModelBase {
  static className = 'GarbageModel';
  classProperties: IPropsGarbageModel;

  constructor(props: IPropsGarbageModel, geometry: IGeometryModel) {
    super(geometry, GarbageModel.className);
    this.classProperties = props;
  }
}
